import { useRouteState } from '@shared/utils'
import { ServiceRouteState } from './state'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { Divider, RouterLink } from '@shared/ui'
import { useTranslation } from 'react-i18next'
import { ROUTE_PATH } from 'apps/social-referent/src/routes/enums'
import { ServicesLink, ServicesWrapper } from './styles'
import { Button, ShieldCheckIcon } from '@shared/storybook'
import { Add, ChevronRight } from '@carbon/icons-react'
import { useNavigate } from 'react-router-dom'
import { SERVICE_TYPES } from '@shared/data-access'

export const Services = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()

  const { personServices, requestService } = useRouteState(ServiceRouteState, {
    policyId: id,
  })

  const showInfo = personServices?.some(
    (service) => service.id && service.personServiceState >= 0 && service.personServiceState !== 99,
  )

  const startProcess =
    !personServices?.length || !personServices?.some((service) => service.id)

  const preventivePowersService = personServices?.find(
    (service) =>
      service.service?.serviceType === SERVICE_TYPES.PREVENTIVE_POWERS,
  )

  const handleRequestPreventivePowers = async () => {
    try {
      const personService = await requestService(
        SERVICE_TYPES.PREVENTIVE_POWERS,
      )

      if (personService) {
        navigate(
          `${ROUTE_PATH.userArea(id)}/service-detail/${personService.id}`,
        )
      }
    } catch (error) {
      console.error('Error requesting preventive powers service:', error)
    }
  }

  const filteredServices =
    personServices?.filter(
      (service) =>
        service.service?.serviceType !== SERVICE_TYPES.PREVENTIVE_POWERS,
    ) || []

  return (
    <div className={ServicesWrapper}>
      {filteredServices.length > 0 &&
        filteredServices.map((personService, index) => (
          <div key={index}>
            <div className={ServicesLink} key={personService.id}>
              <div className="flex flex-row items-center gap-8">
                <ShieldCheckIcon />
                {t(`${personService.service.serviceName}.title`)}
              </div>
              {showInfo && (
                <div className="flex flex-row items-center gap-4">
                  <RouterLink
                    className="text-primary-500 text-[14px]"
                    to={`${ROUTE_PATH.userArea(id)}/service-detail/${
                      personService.id
                    }`}
                  >
                    {t('userArea.monitoringArea.services.seeService')}
                  </RouterLink>
                  <ChevronRight
                    className="text-primary-500"
                    width={24}
                    height={24}
                  />
                </div>
              )}
              {!showInfo && startProcess && (
                <Button
                  endIcon={
                    <Add className="text-white" width={24} height={24} />
                  }
                  variant="primary-500"
                  onClick={() => {
                    navigate(
                      `${ROUTE_PATH.userArea(id)}/service-detail/${
                        personService.id
                      }`,
                    )
                  }}
                  className="text-[14px]"
                >
                  {t('userArea.monitoringArea.services.askForService')}
                </Button>
              )}
            </div>
            <Divider className="mt-4" />
          </div>
        ))}

      <div>
        <div className={ServicesLink}>
          <div className="flex flex-row items-center gap-8">
            <ShieldCheckIcon />
            {preventivePowersService
              ? t(`${preventivePowersService.service.serviceName}.title`)
              : t('serviceType.preventivePowers.title')}

          </div>
          {preventivePowersService &&
            preventivePowersService.personServiceState >= 0 &&
            preventivePowersService.personServiceState !== 99 && (
              <div className="flex flex-row items-center gap-4">
                <RouterLink
                  className="text-primary text-[14px]"
                  to={`${ROUTE_PATH.userArea(id)}/service-detail/${
                    preventivePowersService.id
                  }`}
                >
                  {t('userArea.monitoringArea.services.seeService')}
                </RouterLink>
                <ChevronRight
                  className="text-primary"
                  width={24}
                  height={24}
                />
              </div>
            )}
          {!preventivePowersService && (
            <Button
              endIcon={<Add className="text-white" width={24} height={24} />}
              variant="primary"
              onClick={handleRequestPreventivePowers}
              className="text-[14px]"
            >
              {t('userArea.monitoringArea.services.askForService')}
            </Button>
          )}
        </div>
        <Divider className="mt-4" />
      </div>
    </div>
  )
})
